'use strict';

// Array#includes is stage 4, in ES7/ES2016
require('array-includes/shim')();

require('./es2017');



//////////////////
// WEBPACK FOOTER
// ./~/airbnb-js-shims/target/es2016.js
// module id = 163
// module chunks = 0